import React, {useEffect, useState} from 'react';
import { useFirestore } from 'reactfire';
import { Skeleton, Collapse, Tabs, Empty } from 'antd';
import FinalReport from '../../Components/Report/FinalReport';
import {useParams} from 'react-router-dom';
const { Panel } = Collapse;
const PatientAppointmentHistory = () => {
    let { id } = useParams();

    const firestore = useFirestore();
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getCurrentCCLocation();
        return () => {
            // Clean up the subscription
            setAppointments([]);
        };
    }, []);

    const getCurrentCCLocation = () => {
        setLoading(true);
        let records = [];
        firestore.collection("appointments").orderBy('date').where("patient_id", "==", id).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            setAppointments(records.reverse());
            setLoading(false);
        })
    }

    const date_options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true};

    return (
        <>
            {loading ? <Skeleton active /> : 
            <React.Fragment>
                <Collapse accordion>
                    {appointments && appointments.map((appint)=> {
                        return <Panel header={new Date(appint.data.date_string).toLocaleDateString('en-US', date_options)} key={appint.id}>
                            <><p className="app_Note"><strong>Note:</strong> {appint.data.note}</p>
                            <div style={{position: 'relative'}}>
                                <FinalReport historyPage={true} appID={appint.id} appDate={appint.data.date_string} patientID={id}/>
                            </div></>
                        </Panel>
                    })}
                </Collapse>
            </React.Fragment>
            }
        </>
    );
}

export default PatientAppointmentHistory;
